// extracted by css-extract-rspack-plugin
export default {"cls1":"Comment-cls1_wN7","cls2":"Comment-cls2_cQf Comment-cls1_wN7"};